import { GroupTypeModel } from "./group-type.model";

export class GroupSearchCriteriaModel {
    public GroupName: string | null;
    public IsActive: boolean | null;
    public IsVoucher: GroupSearchIsVoucherCriteria | null;
    public UserId: string | null;
    public NotAssignedGroupOnly: boolean | null;
    public GroupTypes: GroupTypeModel[];
}

export enum GroupSearchIsVoucherCriteria {
    NA = 1,
    Yes = 2,
    No = 4,
    All = NA | No | Yes,
}